import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ReportFilters } from '@views/pages/Reporting/Reports/types.ts';

type ReportTableFiltersStore = {
  filters: ReportFilters;
  setFilter: (filters: ReportFilters) => void;
};

export const useReportTableFiltersStore = create<ReportTableFiltersStore>()(
  persist(
    set =>
      ({
        filters: {
          search: '',
          page: 1,
          limit: 100,
          sort_by: 'name',
          sort_order: 'ASC',
          organization_id: '',
          report_folder_id: '',
          tabIndex: '1',
        },
        setFilter: newFilters => set({ filters: { ...newFilters } }),
      }) as ReportTableFiltersStore,
    {
      name: 'report-table-filters-store',
      partialize: state => ({
        filters: state.filters,
      }),
    },
  ),
);
